/**
 * Gallery (Social Hub) images — served from Gallery Cloudinary only.
 * Do not use insightImage transforms here.
 */
export function getGalleryImageUrl(url) {
  if (!url) return null;
  if (typeof url === "string" && url.startsWith("https://res.cloudinary.com/")) {
    return url;
  }
  if (typeof url === "string" && (url.startsWith("http://") || url.startsWith("https://"))) {
    return url;
  }
  console.warn("[Gallery] Invalid or legacy image URL:", url);
  return null;
}
